import * as THREE from 'three';

export class Material extends THREE.Material {
    name: string;
    title: string;
    desc: string;
}
